import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import { readJsonString } from "../../../../util/json.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketInJoinLobby extends PacketIn {
    public static readonly LOBBY_ID_KEY = "lobby_id";

    public lobbyID: string | null = null;

    constructor() {
        super(InboundPacketType.JOIN_LOBBY);
    }

    getLobbyID(): string {
        if (this.lobbyID === null)
            throw new Error("Packet has not been read yet");
        return this.lobbyID;
    }

    override readContents(
        _context: MessageIOContext,
        json: Record<string, any>,
    ): void {
        this.lobbyID = readJsonString(json, PacketInJoinLobby.LOBBY_ID_KEY);
    }
}
